export enum EAgentType {
	OUTBOUND = 'Outbound',
	INBOUND = 'Inbound',
}
